"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LineItemStates;
(function (LineItemStates) {
    LineItemStates["INPROGRESS"] = "line-item-provisioning-in-progress";
    LineItemStates["DELAYED"] = "line-item-provisioning-delayed";
    LineItemStates["FAILED"] = "line-item-provisioning-failed";
    LineItemStates["PROVISIONED"] = "line-item-provisioned";
    LineItemStates["PENDING_PROVISION"] = "line-item-pending-provision";
    LineItemStates["OFFLINEPROVISIONING"] = "line-item-offline-provisioning";
    LineItemStates["LEGACYPROVISIONED"] = "line-item-legacy-provisioned";
    LineItemStates["LEGACYCANCELLED"] = "line-item-legacy-cancelled";
    LineItemStates["CANCELLED_AND_DEPROVISIONED"] = "line-item-deprovisioned-cancelled";
    LineItemStates["AWAITING_SHIPMENT"] = "line-item-awaiting-shipment";
    LineItemStates["SHIPPED"] = "line-item-shipped";
    LineItemStates["DEPROVISIONED_EXPIRED"] = "line-item-deprovisioned-expired";
    LineItemStates["DEPROVISIONED_CANCELLED"] = "line-item-deprovisioned-cancelled";
    LineItemStates["INITIAL"] = "Initial";
})(LineItemStates = exports.LineItemStates || (exports.LineItemStates = {}));
var OrderStates;
(function (OrderStates) {
    OrderStates["NONE"] = "";
    OrderStates["COMPLETE"] = "Complete";
    OrderStates["FAILED"] = "order-failed";
    OrderStates["CANCELLED"] = "Cancelled";
})(OrderStates = exports.OrderStates || (exports.OrderStates = {}));
var OrderPreviewTypes;
(function (OrderPreviewTypes) {
    OrderPreviewTypes["OrderMetrics"] = "OrderMetrics";
    OrderPreviewTypes["BillingDocs"] = "BillingDocs";
    OrderPreviewTypes["ChargeMetrics"] = "ChargeMetrics";
})(OrderPreviewTypes = exports.OrderPreviewTypes || (exports.OrderPreviewTypes = {}));
var Carriers;
(function (Carriers) {
    Carriers["FEDEX"] = "fedex";
    Carriers["USPS"] = "stamps_com";
})(Carriers = exports.Carriers || (exports.Carriers = {}));
var PreCandidateOrder;
(function (PreCandidateOrder) {
    PreCandidateOrder["sku"] = "MEMSTUAFF0122";
    PreCandidateOrder["productName"] = "AICPA Student Affiliate";
    PreCandidateOrder["membershipMonthStart"] = "august";
    PreCandidateOrder["membershipMonthEnd"] = "july";
})(PreCandidateOrder = exports.PreCandidateOrder || (exports.PreCandidateOrder = {}));
var CreateOrderType;
(function (CreateOrderType) {
    CreateOrderType["CREATE_ZERO_PRICE_ORDER"] = "CREATE_ZERO_PRICE_ORDER";
    CreateOrderType["CREATE_SALESFORCE_ORDER"] = "CREATE_SALESFORCE_ORDER";
})(CreateOrderType = exports.CreateOrderType || (exports.CreateOrderType = {}));
var PeriodType;
(function (PeriodType) {
    PeriodType["DAY"] = "Day";
    PeriodType["WEEK"] = "Week";
    PeriodType["MONTH"] = "Month";
    PeriodType["YEAR"] = "Year";
})(PeriodType = exports.PeriodType || (exports.PeriodType = {}));
var TermType;
(function (TermType) {
    TermType["TERMED"] = "TERMED";
    TermType["EVERGREEN"] = "EVERGREEN";
})(TermType = exports.TermType || (exports.TermType = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["RECURRING"] = "RECURRING";
    DiscountType["ONETIME"] = "ONETIME";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var TriggerEvents;
(function (TriggerEvents) {
    TriggerEvents["ContractEffective"] = "ContractEffective";
    TriggerEvents["ServiceActivation"] = "ServiceActivation";
    TriggerEvents["CustomerAcceptance"] = "CustomerAcceptance";
})(TriggerEvents = exports.TriggerEvents || (exports.TriggerEvents = {}));
var OrderActionType;
(function (OrderActionType) {
    OrderActionType["CREATE_SUBSCRIPTION"] = "CreateSubscription";
    OrderActionType["OWNER_TRANSFER"] = "OwnerTransfer";
    OrderActionType["RENEW_SUBSCRIPTION"] = "RenewSubscription";
    OrderActionType["TERMS_AND_CONDITIONS"] = "TermsAndConditions";
    OrderActionType["ADD_PRODUCT"] = "AddProduct";
    OrderActionType["REMOVE_PRODUCT"] = "RemoveProduct";
    OrderActionType["CANCEL_SUBSCRIPTION"] = "CancelSubscription";
})(OrderActionType = exports.OrderActionType || (exports.OrderActionType = {}));
var RenewalSetting;
(function (RenewalSetting) {
    RenewalSetting["RENEW_TO_EVERGREEN"] = "RENEW_TO_EVERGREEN";
    RenewalSetting["RENEW_WITH_SPECIFIC_TERM"] = "RENEW_WITH_SPECIFIC_TERM";
})(RenewalSetting = exports.RenewalSetting || (exports.RenewalSetting = {}));
exports.RefundCancellationOptions = [
    {
        key: 1,
        text: 'Cancellation with full refund',
        value: 'Refund-with-cancellation',
    },
    {
        key: 2,
        text: 'Cancellation with partial refund',
        value: 'Partial-refund-with-cancellation',
    },
    {
        key: 3,
        text: 'Cancellation with no refund',
        value: 'Cancel-only',
    },
    {
        key: 4,
        text: 'Refund with no cancellation',
        value: 'Refund-without-cancellation',
    },
];
var SourceSystems;
(function (SourceSystems) {
    SourceSystems["BLUE_MARTINI"] = "blue-martini";
    SourceSystems["EBS"] = "ebs";
    SourceSystems["NETFORUM"] = "netforum";
    SourceSystems["RAVE"] = "rave";
    SourceSystems["RAVE_B2B"] = "rave-b2b";
    SourceSystems["RAVE_FB"] = "rave-fb";
    SourceSystems["SIEBEL"] = "siebel";
    SourceSystems["TWTCPA"] = "twtcpa";
})(SourceSystems = exports.SourceSystems || (exports.SourceSystems = {}));
var AccessOrderType;
(function (AccessOrderType) {
    AccessOrderType["ACCESS_ONLY"] = "acc";
    AccessOrderType["BENEFIT"] = "ben";
    AccessOrderType["FIRM_BILLING"] = "fb";
    AccessOrderType["IMPORT"] = "ext";
    AccessOrderType["SEAT_MANAGEMENT"] = "seat";
})(AccessOrderType = exports.AccessOrderType || (exports.AccessOrderType = {}));
var OrderPrefix;
(function (OrderPrefix) {
    OrderPrefix["B2C"] = "2";
    OrderPrefix["B2B"] = "3";
    OrderPrefix["FIRM_BILLING"] = "4";
    OrderPrefix["FIRM_BILLING_OWNERSHIP"] = "5";
})(OrderPrefix = exports.OrderPrefix || (exports.OrderPrefix = {}));
var RaveChannels;
(function (RaveChannels) {
    RaveChannels["EXTERNAL"] = "external";
    RaveChannels["RAVE"] = "rave";
    RaveChannels["RAVE_B2B"] = "rave-b2b";
    RaveChannels["RAVE_FIRM_BILLING"] = "rave-firm-billing";
})(RaveChannels = exports.RaveChannels || (exports.RaveChannels = {}));
var ZuoraAsyncJobType;
(function (ZuoraAsyncJobType) {
    ZuoraAsyncJobType["PREVIEW"] = "preview";
    ZuoraAsyncJobType["ORDER"] = "order";
})(ZuoraAsyncJobType = exports.ZuoraAsyncJobType || (exports.ZuoraAsyncJobType = {}));
var PaymentMandateStatus;
(function (PaymentMandateStatus) {
    PaymentMandateStatus["active"] = "Active";
    PaymentMandateStatus["inactive"] = "Inactive";
    PaymentMandateStatus["invalid"] = "Invalid";
})(PaymentMandateStatus = exports.PaymentMandateStatus || (exports.PaymentMandateStatus = {}));
var PaymentMandateType;
(function (PaymentMandateType) {
    PaymentMandateType["DIRECT_DEBIT"] = "Direct Debit";
    PaymentMandateType["ach"] = "Automated Clearing House (ACH)";
})(PaymentMandateType = exports.PaymentMandateType || (exports.PaymentMandateType = {}));
exports.errorCodeDescriptions = {
    "01": "Your credit card was declined. Please try another card or contact your card issuer to ask if they have blocked this transaction. If they have blocked it ask them to release the block.",
    "05": "We had a problem processing your payment. Please contact your card issuing bank or use an alternate payment method.",
    "14": "We had a problem processing your payment. Please check your credit card number. If you're still experiencing issues, contact the Global Engagement Center.",
    "33": "We had a problem processing your payment. Please check your expiration date and try again or use an alternative payment method.",
    "64": "We had a problem processing your payment. Please check your CVV number and try again or use an alternative payment method.",
    "89": "Insufficient funds.",
    "C4": "We had a problem processing your payment. Please contact your bank or use an alternative payment method.",
    "D7": "We had a problem processing your payment. Please contact your bank or use an alternative payment method.",
    "default": "We had an issue processing your payment. Please contact your bank or use an alternative payment method.",
};
//# sourceMappingURL=index.js.map